<div class="radio-group-container" [class.horizontal]="horizontal">
  <div *ngFor="let option of options; let i = index">
    <p-radioButton
      [disabled]="option.isAvailable != null ? !option.isAvailable : false"
      label="{{ optionLabel ? option[optionLabel] : option }}"
      inputId="{{ dataKey ? option[dataKey] + groupName : option }}"
      [name]="groupName"
      [value]="dataKey ? option[dataKey] : option"
      [formControl]="formControl"
    ></p-radioButton>
  </div>
</div>
